<template>
  <v-card :loading="!!!Object.keys(appLayout).length">
    <v-card-title v-if="!!Object.keys(appLayout).length">
      <span class="text-h5">Edit {{ appLayout.name }}</span>
    </v-card-title>

    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ e[0] }}
        </v-alert>
      </div>

      <v-form
        v-if="!!Object.keys(appLayout).length"
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="validate"
      >
        <v-text-field
          v-model="appLayout.name"
          :rules="rules.required"
          label="Name *"
        ></v-text-field>

        <v-text-field
          v-model="appLayout.instance"
          :rules="rules.required"
          label="Instance *"
        ></v-text-field>

        <v-text-field
          v-model="appLayout.primary_color"
          :rules="rules.required"
          label="Primary color *"
        ></v-text-field>

        <v-text-field
          v-model="appLayout.secondary_color"
          :rules="rules.required"
          label="Secondary color *"
        ></v-text-field>

        <v-text-field
          v-model="appLayout.emails"
          hint="services@bonacasa.ch; alexey.moroz@bonacasa.ch"
          label="Emails"
        ></v-text-field>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="cancel">Cancel</v-btn>
            <v-btn type="submit" color="success" :disabled="!valid">
              Update
            </v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AppLayoutsEdit',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    appLayout: {},
    error: null,

    valid: true,
    rules: {
      required: [v => !!v || 'Field is required']
    }
  }),

  created() {
    this.$store
      .dispatch('app_layout/retrieveAppLayout', this.id)
      .then(({ data }) => {
        this.appLayout = data;
      });
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('app_layout/update', {
            app_layout: this.appLayout
          })
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    }
  }
};
</script>
